import EnumCustomTextModelCreator from "../EnumCustomTextModelCreator.js";
const TYPE = 'attr.customTextAttribute.resourceEnum';
export default EnumCustomTextModelCreator.createModel(TYPE);